import React, {useState} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';

const LocationLogo = ({name, iconUrl}) => {
    const [logoWide, setLogoWide] = useState(false);

    return (
        <img
            alt={name}
            className={classNames('logo', {'logo-wide': logoWide})}
            src={prependDigitalAssetsUrl(iconUrl)}
            onLoad={e => {
                const width = e.target?.naturalWidth;
                const height = e.target?.naturalHeight;
                setLogoWide(width && height && width / height > 3);
            }}
        />
    );
};

LocationLogo.propTypes = {
    name: PropTypes.string,
    iconUrl: PropTypes.string,
};

export default LocationLogo;
